import Splide from '@splidejs/splide';

const LandingPageHero = () => {
    const sections = document.querySelectorAll('.block-landing-page-hero');

    let lastTheme = null;

    for (const section of sections) {
        const splideImageElement = section.querySelector('.splide-image');
        const splideContentElement = section.querySelector('.splide-content');
        if (!splideImageElement || !splideContentElement) continue;

        const contentSlider = new Splide( splideContentElement, {
            perPage: 1,
            mediaQuery: 'min',
            isNavigation: true,
            type: 'fade',
            drag: false,
        } );
        const imageSlider = new Splide( splideImageElement, {
            perPage: 1,
            mediaQuery: 'min',
            arrows: false,
            pagination: false,
            type: 'fade',
            drag: false,
        } );

        const colImage = section.querySelector('.col-image');
        const updateTheme = (index) => {
            const slides = contentSlider.Components.Slides.get();
            if (!index) index = 0;
            const newTheme = slides[index].slide.dataset.theme;

            if (newTheme) {
                if (!lastTheme) {
                    lastTheme = section.dataset.theme;
                }
                if (lastTheme) {
                    section.classList.remove('bg-' + lastTheme);
                    section.classList.remove('fg-' + lastTheme);
                    section.classList.add('bg-' + newTheme);
                    section.classList.add('fg-' + newTheme);
                    colImage.classList.remove('text-' + lastTheme);
                    colImage.classList.add('text-' + newTheme);
                    lastTheme = newTheme;
                }
            }
        }

        contentSlider.on('move', updateTheme);
        contentSlider.on('mounted', updateTheme);

        contentSlider.mount();
        imageSlider.mount();
        contentSlider.sync( imageSlider );

    }
}

export default LandingPageHero;